<div class="container h-full flex flex-col mx-auto px-4 md:px-6 pt-8 pb-4">
  <div class="flex items-center mb-4 min-h-10">
    <h2 class="text-2xl font-medium">Rollen</h2>
    <div class="ml-auto flex items-center gap-2">
      <button mat-button (click)="handleOpenMatrix()">
        <mat-icon>grid_on</mat-icon>
        Rechten matrix
      </button>

      @if (isRootUnit()) {
        <button *appHasPermission="'user_role:create'" mat-button (click)="handleCreateRole()">
          <mat-icon>add</mat-icon>
          Nieuwe rol
        </button>
      }
    </div>
  </div>

  <div class="bg-white p-4 rounded-t-lg">
    <mat-form-field
      subscriptSizing="dynamic"
      class="w-full [--mat-form-field-container-text-size:14px] [--mat-form-field-container-height:48px] [--mat-form-field-container-vertical-padding:12px]"
    >
      <mat-icon matPrefix> search </mat-icon>

      <input
        #searchInput
        matInput
        placeholder="Zoeken op naam..."
        [ngModel]="keyword()"
        (ngModelChange)="handleSearch(searchInput.value)"
      />

      @if (keyword()) {
        <button mat-icon-button matSuffix class="mr-1" (click)="clearSearch()">
          <mat-icon>cancel</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>

  <app-data-table-container class="rounded-b-lg">
    <table
      mat-table
      matSort
      matSortDirection="asc"
      matSortActive="label"
      matSortDisableClear
      [matSortDisabled]="hasNoData()"
      (matSortChange)="handleSortChange($event)"
      [dataSource]="dataSource()"
    >
      <ng-container matColumnDef="label" sticky>
        <th mat-header-cell *matHeaderCellDef mat-sort-header="label">Naam</th>
        <td mat-cell *matCellDef="let element">
          <span
            class="w-min max-w-40 truncate block"
            [matTooltip]="element.label"
            matTooltipPosition="after"
            >{{ element.label }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Omschrijving</th>
        <td mat-cell *matCellDef="let element">
          <span
            class="w-min max-w-60 truncate block"
            [matTooltip]="element.description"
            matTooltipPosition="after"
            >{{ element.description || '—' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="permissionCount">
        <th mat-header-cell *matHeaderCellDef>Rechten</th>
        <td mat-cell *matCellDef="let element">
          {{ element.permissions.length }} {{ element.permissions.length === 1 ? 'recht' : 'rechten' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="created_at">
          Aangemaakt op
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.createdAt | date: 'MMMM dd, yyyy HH:mm' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          @if (isRootUnit()) {
            <button *appHasPermission="['user_role:update', 'user_role:delete']" mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #menu="matMenu">
              <button *appHasPermission="'user_role:update'" mat-menu-item (click)="handleEditRole(element)">Bewerken</button>

              <button *appHasPermission="'user_role:delete'" mat-menu-item (click)="handleDeleteRole(element)">
                Verwijderen
              </button>
            </mat-menu>
          }
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
        class="whitespace-nowrap"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="hover:!bg-gray-100 whitespace-nowrap"
        (dblclick)="handleEditRole(row)"
      ></tr>

      <tr class="mat-mdc-row" *matNoDataRow>
        <td
          class="mat-mdc-cell mdc-data-table__cell !border-none"
          [colSpan]="displayedColumns.length"
        >
          Geen resultaten gevonden
        </td>
      </tr>
    </table>

    <div paginator class="border-t border-gray-200 min-h-14"></div>
  </app-data-table-container>
</div>
